import React, {Component} from 'react';
import NotificationSystem from 'react-notification-system';
import HeaderSteps from './HeaderSteps';
import Upload from './steps/Upload';
import Assignment from './steps/Assignment';
import Download from './steps/Download';
import SupplierRules from './SupplierRules';
import RuleUpdateModal from './rules/RuleUpdateModal';
import {supplierApi} from '../../api';

class Supplier extends Component {

    invoiceInternalId = 0;

    invoiceItemInternalId = 0;

    constructor(props) {
        super(props);

        this.state = {
            company: null,
            config: null,
            currentStep: 1,

            onlineszamlaToken: false,
            showRulesPage: false,
            editRule: null,

            invoices: [],
            supplierRules: [],
            vatCollectorCodes: [],
            partners: [],
        };

        this.notificationSystemRef = React.createRef();
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0);

        try {
            const responseData = await supplierApi.initialize(
                this.getCompanyId(),
            );

            this.setState({
                company: responseData.company,
                config: responseData.config,
                vatCollectorCodes: responseData.vatCollectorCodes || [],
                supplierRules: responseData.supplierRules || [],
                onlineszamlaToken: Boolean(
                    responseData.onlineszamlaToken,
                ),
            });
        } catch (error) {
            this.notifyError(
                this.getErrorMessage(
                    error,
                    'A szállítói adatok betöltése sikertelen.',
                ),
            );
        }
    };

    getCompanyId = () => {
        return this.props.location.match.params.id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    notifySuccess = (message) => {
        if (!this.notificationSystemRef.current) {
            return;
        }

        this.notificationSystemRef.current.addNotification({
            message,
            level: 'success',
            position: 'tc',
            autoDismiss: 10,
        });
    };

    notifyError = (message) => {
        if (!this.notificationSystemRef.current) {
            return;
        }

        this.notificationSystemRef.current.addNotification({
            message,
            level: 'error',
            position: 'tc',
            autoDismiss: 10,
        });
    };

    setStep = (currentStep) => {
        this.setState({currentStep});
    };

    nextStep = () => {
        this.setState((previousState) => ({
            currentStep: previousState.currentStep + 1,
        }));
    };

    toggleRulesPage = () => {
        this.setState((previousState) => ({
            showRulesPage: !previousState.showRulesPage,
        }));
    };

    setData = (data) => {
        this.setState(data);
    };

    updateRules = (supplierRules) => {
        this.updateInvoices(
            this.state.invoices,
            supplierRules,
        );
    };

    updatePartners = (partners) => {
        this.setState({
            partners: partners || [],
        });
    };

    updateConfig = (config) => {
        this.setState({config});
    };

    editRule = (rule) => {
        this.setState({
            editRule: rule,
        });
    };

    ensureInternalIds = (invoices) => {
        return (invoices || []).map(
            (invoice) => ({
                ...invoice,

                _internalId: invoice._internalId
                    || ++this.invoiceInternalId,

                items: (invoice.items || []).map(
                    (invoiceItem) => ({
                        ...invoiceItem,

                        _internalId: invoiceItem._internalId
                            || ++this.invoiceItemInternalId,
                    }),
                ),
            }),
        );
    };

    getVatCollectorTitle = (vatCollectorId) => {
        if (!vatCollectorId) {
            return '';
        }

        const vatCollector = this.state.vatCollectorCodes.find(
            (item) => item.id === vatCollectorId,
        );

        return vatCollector ? vatCollector.title : '';
    };

    applyRuleToInvoiceItem = (invoiceItem, rule) => {
        return {
            ...invoiceItem,
            main_bookkeeping_number: rule.main_bookkeeping_number,
            vat_collector_id: rule.vat_collector_id,
            vat_collector_title: this.getVatCollectorTitle(
                rule.vat_collector_id,
            ),
            vat_degree: rule.vat_degree,
            rule_id: rule.id,
        };
    };

    clearRuleFromInvoiceItem = (invoiceItem) => {
        return {
            ...invoiceItem,
            rule_id: null,
            main_bookkeeping_number: null,
            vat_collector_id: null,
            vat_collector_title: null,
            vat_degree: null,
        };
    };

    updateInvoices = (invoices, supplierRules) => {
        let addRuleCount = 0;

        const invoicesWithInternalIds = this.ensureInternalIds(invoices);

        const updatedInvoices = invoicesWithInternalIds.map(
            (invoice) => {
            const updatedItems = (invoice.items || []).map((invoiceItem) => {
                const selectedRule = this.invoiceFindRule(
                    invoice,
                    invoiceItem,
                    supplierRules || [],
                );

                if (selectedRule) {
                    if (invoiceItem.rule_id !== selectedRule.id) {
                        addRuleCount += 1;
                    }

                    return this.applyRuleToInvoiceItem(
                        invoiceItem,
                        selectedRule,
                    );
                }

                if (invoiceItem.rule_id) {
                            return this.clearRuleFromInvoiceItem(
                                invoiceItem,
                            );
                }

                return invoiceItem;
                    },
                );

            return {
                ...invoice,
                items: updatedItems,
            };
            },
        );

        if (addRuleCount > 0) {
            this.notifySuccess(
                `${addRuleCount} darab sor sikeresen kontírozva.`,
            );
        }

        this.setState({
            invoices: updatedInvoices,
            supplierRules: supplierRules || [],
        });
    };

    invoiceFindRule = (
        invoice,
        invoiceItem,
        supplierRules,
    ) => {
        return supplierRules.find((rule) => (
            this.invoiceCheckRule(
                invoice,
                invoiceItem,
                rule,
            )
            ),
        ) || null;
    };

    invoiceCheckRule = (
        invoice,
        invoiceItem,
        rule,
    ) => {
        const supplierName = (
            invoice
            && invoice.supplier
            && invoice.supplier.name
        )
            ? invoice.supplier.name
            : '';

        const itemName = (
            invoiceItem
            && invoiceItem.name
        )
            ? invoiceItem.name
            : '';

        const positionNumberCountry = (
            invoice
            && invoice.positionNumberCountry
        )
            ? invoice.positionNumberCountry
            : '';

        const orderNumberStat = (
            invoice
            && invoice.orderNumberStat
        )
            ? invoice.orderNumberStat
            : '';

        if (
            rule.supplier_name
            && supplierName.toUpperCase()
            !== rule.supplier_name.toUpperCase()
        ) {
            return false;
        }

        if (
            rule.item_name
            && !itemName
                .toUpperCase()
                .includes(
                    rule.item_name.toUpperCase(),
                )
        ) {
            return false;
        }

        if (
            rule.position_number_country
            && !positionNumberCountry
                .toUpperCase()
                .includes(
                    rule.position_number_country
                        .toUpperCase(),
                )
        ) {
            return false;
        }

        if (
            rule.order_number_stat
            && !orderNumberStat
                .toUpperCase()
                .includes(
                    rule.order_number_stat
                        .toUpperCase(),
                )
        ) {
            return false;
        }

        const ruleVat = Number(rule.vat);
        const invoiceItemVat = Number(invoiceItem.vatPercentage) * 100;

        return ruleVat === invoiceItemVat;
    };

    renderLoading = () => {
        return (
            <section id="supplier-upload">
                <NotificationSystem
                    ref={this.notificationSystemRef}
                />
            </section>
        );
    };

    renderCompanyHeader = () => {
        return (
            <div className="header mb-5">
                <div
                    className="container"
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <h1>
                        Szállító számlák kontírozása
                    </h1>

                    <button
                        type="button"
                        className="table-green-btn"
                        onClick={this.toggleRulesPage}
                    >
                        Szabályok
                    </button>
                </div>
            </div>
        );
    };

    renderUploadStep = () => {
        if (this.state.currentStep !== 1) {
            return null;
        }

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-10 offset-md-1">
                        <Upload
                            config={this.state.config}
                            vatCollectorCodes={
                                this.state.vatCollectorCodes
                            }
                            supplierRules={
                                this.state.supplierRules
                            }
                            invoices={this.state.invoices}
                            updateInvoices={this.updateInvoices}
                            updatePartners={this.updatePartners}
                            updateConfig={this.updateConfig}
                            nextStep={this.nextStep}
                            notifySuccess={this.notifySuccess}
                            notifyError={this.notifyError}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderAssignmentStep = () => {
        if (this.state.currentStep !== 2) {
            return null;
        }

        return (
            <Assignment
                config={this.state.config}
                vatCollectorCodes={this.state.vatCollectorCodes}
                invoices={this.state.invoices}
                supplierRules={this.state.supplierRules}
                nextStep={this.nextStep}
                setData={this.setData}
                updateInvoices={this.updateInvoices}
                updateRules={this.updateRules}
                notifySuccess={this.notifySuccess}
                notifyError={this.notifyError}
            />
        );
    };

    renderDownloadStep = () => {
        if (this.state.currentStep !== 3) {
            return null;
        }

        return (
            <Download
                config={this.state.config}
                invoices={this.state.invoices}
                partners={this.state.partners}
                notifySuccess={this.notifySuccess}
                notifyError={this.notifyError}
            />
        );
    };

    renderMainContent = () => {
        return (
            <div>
                <HeaderSteps
                    setStep={this.setStep}
                    currentStep={this.state.currentStep}
                />

                {this.renderCompanyHeader()}

                <div className="upload-body">
                    {this.renderUploadStep()}
                    {this.renderAssignmentStep()}
                    {this.renderDownloadStep()}
                </div>
            </div>
        );
    };

    renderRulesPage = () => {
        return (
            <SupplierRules
                config={this.state.config}
                supplierRules={this.state.supplierRules}
                vatCollectorCodes={this.state.vatCollectorCodes}
                company={this.state.company}
                toggleRulesPage={this.toggleRulesPage}
                updateRules={this.updateRules}
                editRule={this.editRule}
                notifySuccess={this.notifySuccess}
                notifyError={this.notifyError}
            />
        );
    };

    renderRuleUpdateModal = () => {
        if (!this.state.editRule) {
            return null;
        }

        return (
            <RuleUpdateModal
                config={this.state.config}
                rule={this.state.editRule}
                vatCollectorCodes={this.state.vatCollectorCodes}
                editRule={this.editRule}
                updateRules={this.updateRules}
                notifySuccess={this.notifySuccess}
                notifyError={this.notifyError}
            />
        );
    };

    render() {
        if (!this.state.company) {
            return this.renderLoading();
        }

        return (
            <section id="supplier-upload">
                {this.state.showRulesPage
                    ? this.renderRulesPage()
                    : this.renderMainContent()
                }

                {this.renderRuleUpdateModal()}

                <NotificationSystem
                    ref={this.notificationSystemRef}
                />
            </section>
        );
    }

}

export default Supplier;


// WEBPACK FOOTER //
// ./src/components/supplier/Supplier.js